import { SessionCompany } from './auth-session.model';

/** Etiqueta de membresía en UI: Administrador vs Colaborador. */
export function companyMembershipLabelKey(roleName: string | null | undefined): string {
  const normalized = (roleName ?? '').trim().toLowerCase();
  if (normalized === 'owner') {
    return 'header.workspacePicker.roleOwner';
  }
  return 'header.workspacePicker.roleMember';
}

export function isCompanyOwnerRole(roleName: string | null | undefined): boolean {
  return (roleName ?? '').trim().toLowerCase() === 'owner';
}

/** True si el usuario ya es dueño de al menos un negocio. */
export function userOwnsAnyCompany(companies: SessionCompany[]): boolean {
  return companies.some((company) => isCompanyOwnerRole(company.roleName));
}

export function companyInitials(name: string): string {
  const parts = name
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2);
  if (parts.length === 0) {
    return '?';
  }
  return parts.map((part) => part.charAt(0).toUpperCase()).join('');
}

const FALLBACK_BRAND_COLORS = [
  '#1f2937',
  '#0f766e',
  '#1d4ed8',
  '#b45309',
  '#9f1239',
  '#4c1d95',
];

export function companyBrandFallbackColor(companyId: number, primaryColor?: string | null): string {
  const trimmed = (primaryColor ?? '').trim();
  if (/^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(trimmed)) {
    return trimmed;
  }
  const index = Math.abs(companyId) % FALLBACK_BRAND_COLORS.length;
  return FALLBACK_BRAND_COLORS[index];
}
